const ServicesMarquee = () => {
  return (
    <div className="overflow-x-hidden w-screen">
      <div>
        <div className="relative flex overflow-x-hidden">
          <div className="py-12 animate-marquee whitespace-nowrap ">
            <span className="mx-8 text-8xl">REMOVALS</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">PRUNING</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">ROOF CLEARANCE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">STORM DAMAGE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">TRIMMING</span>
            <span className="mx-8 text-8xl">•</span>
          </div>
          <div className="absolute top-0 py-12 animate-marquee2 whitespace-nowrap">
            <span className="mx-8 text-8xl">REMOVALS</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">PRUNING</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">ROOF CLEARANCE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">STORM DAMAGE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">TRIMMING</span>
            <span className="mx-8 text-8xl">•</span>
          </div>
        </div>

        <div className="relative flex overflow-x-hidden">
          <div className="py-12 animate-marquee3 whitespace-nowrap ">
            <span className="mx-8 text-8xl">REMOVALS</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">PRUNING</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">ROOF CLEARANCE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">STORM DAMAGE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">TRIMMING</span>
            <span className="mx-8 text-8xl">•</span>
          </div>
          <div className="absolute top-0 py-12 animate-marquee4 whitespace-nowrap">
            <span className="mx-8 text-8xl">REMOVALS</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">PRUNING</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">ROOF CLEARANCE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">STORM DAMAGE</span>
            <span className="mx-8 text-8xl">•</span>
            <span className="mx-8 text-8xl">TRIMMING</span>
            <span className="mx-8 text-8xl">•</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesMarquee;
